import utilService from '../../src/services/UtilService';

class IntervalSaver {
    static DEFAULT_MINIMUM_IDLE_TIME = 2000;
    static DEFAULT_CHECKING_INTERVAL = 1000;
    /**
     * @param {*} initialValue
     * @param {function} callback
     */
    constructor(initialValue, callback) {
        this.callback = callback;
        this.currentValue = initialValue;
        this.intervalHandle = undefined;
        this.lastStoredValue = initialValue;
        this.lastSetValueTS = undefined;
        this.onInterval = this.saveIfReady.bind(this, IntervalSaver.DEFAULT_MINIMUM_IDLE_TIME);
    }

    /**
     * Sets a new value to be saved
     * @param {*} value
     */
    setValue(value) {
        this.currentValue = value;
        this.lastSetValueTS = new Date().getTime();
        this.lastStoredValue = value;
        this.callback(value);
    }

    /**
     * Starts an interval that calls this.updateIfReady(minimumIdleTime)
     *
     * @param {int} interval A number of milliseconds
     * @param {int} minimumIdleTime A number of milliseconds
     */
    startInterval(interval) {
        this.intervalHandle = setInterval(this.onInterval, interval);
    }

    saveAndStop() {
        clearInterval(this.intervalHandle);
        this.saveIfReady(0);
    }

    /**
     * Calls this.callback(this.currentValue) if this.currentValue has changed since last call,
     * and minimumIdleTime has passed since last time this.setValue() was called.
     * @param {int} minimumIdleTime A number of milliseconds
     */
    saveIfReady(minimumIdleTime = IntervalSaver.DEFAULT_MINIMUM_IDLE_TIME) {
        const currentTS = utilService.getCurrentTimeStamp();
        if (
            (currentTS - this.lastSetValueTS) > minimumIdleTime
            && this.currentValue !== this.lastStoredValue
        ) {
            this.lastStoredValue = this.currentValue;
            this.callback(this.currentValue);
        }
    }
}

export default IntervalSaver;
